/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* ========================================================================
     EXAU CUSTOM 2026-09-01 — product page waitlist link

     Broadcast's built-in "Sold Out - Notify Me When It's Available" button
     opens a popup that posts through Shopify's CONTACT form. Each signup
     emails hello@ and builds no list — nothing segmentable, nothing
     automatable. It is hidden by assets/exau-custom.css.

     This replaces it with a link to /pages/waitlist, so a sold-out product
     page offers the same path as a sold-out card in the product grid:
       /pages/waitlist -> Flodesk form 68ac8394a306098dd1ca5218
                       -> segment "Waitlist harvest 2025"

     FIX 2026-09-01 (second pass): Broadcast renders
     .product-soldout-notification on EVERY product page, in stock or not —
     it simply hides it when the product is available. The first version of
     this script injected on all of them, so Turi (in stock) showed
     "Notify me when it's back" underneath its Add to Cart button. We now
     check the product's own buy block for a usable Add to cart first, and
     skip injection when one exists. The check is scoped to .product__submit
     so upsell and related-product buttons elsewhere on the page can't
     suppress a genuine sold-out link.

     Kept in custom.js on purpose: this file survived the 6.2.0 -> 8.1.1
     upgrade byte-identical, so it does not need re-applying after a theme
     update (the one line loading it in layout/theme.liquid does).
     ======================================================================== */

  var EXAU_WAITLIST_URL = '/pages/waitlist';
  var EXAU_WAITLIST_LABEL = "Notify me when it's back";

  function exauProductIsBuyable(holder) {
    var submit = holder.closest ? holder.closest('.product__submit') : null;
    if (!submit) return false;
    return !!submit.querySelector('[data-add-to-cart]:not([disabled])');
  }

  function exauAddWaitlistLink() {
    var holders = document.querySelectorAll('.product-soldout-notification');

    for (var i = 0; i < holders.length; i++) {
      var holder = holders[i];
      if (holder.dataset.exauWaitlist) continue;

      // In stock — leave it alone. Not marked as processed, so if a variant
      // change makes it sold out later this runs again and injects then.
      if (exauProductIsBuyable(holder)) continue;

      holder.dataset.exauWaitlist = '1';

      var wrap = document.createElement('div');
      wrap.className = 'product-item__waitlist exau-pdp-waitlist';

      var link = document.createElement('a');
      link.href = EXAU_WAITLIST_URL;
      link.className = 'btn btn--large product-item__waitlist__btn';
      link.textContent = EXAU_WAITLIST_LABEL;

      wrap.appendChild(link);
      holder.parentNode.insertBefore(wrap, holder);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', exauAddWaitlistLink);
  } else {
    exauAddWaitlistLink();
  }

  // Re-run if the theme swaps product content in (variant / sibling changes).
  document.addEventListener('shopify:section:load', exauAddWaitlistLink);
  document.addEventListener('variant:change', exauAddWaitlistLink);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

/* EXAU 2026-09-21 GA4: Flodesk blocks GA4 form_submit, so send waitlist_signup when a Flodesk form shows its success state (class fd-has-success). Once per form per page. Reverse: delete the next line. */
(function(){var sent={};function chk(){document.querySelectorAll('form[class*="fd-has-success"]').forEach(function(f){var a=f.getAttribute('action')||'';var m=a.match(/forms\/([a-z0-9]+)/);var id=m?m[1]:'unknown';if(sent[id])return;sent[id]=1;if(typeof gtag==='function'){gtag('event','waitlist_signup',{form_id:id,form_destination:a,send_to:'G-Y23H25VF42'});}});}new MutationObserver(chk).observe(document.documentElement,{subtree:true,attributes:true,attributeFilter:['class'],childList:true});})();